(function() {
window.alpha_oms.init_bootstrap_toggles = function() {
  return document.querySelectorAll('input[type=checkbox][data-toggle="toggle"]').forEach(function(el) {
    if (el.closest('.toggle') == null) {
      return el.bootstrapToggle();
    }
  });
};

jQuery(function() {
  return window.alpha_oms.init_bootstrap_toggles();
});

$(document).on("click", '[data-show-datepicker]', function(e) {
  var $this;
  $this = $(this);
  e.preventDefault();
  $this.datetimepicker({
    format: "YYYY-MM-DD",
    icons: {
      previous: "fa-solid fa-chevron-left",
      next: "fa-solid fa-chevron-right",
      up: "fa-solid fa-chevron-up",
      down: "fa-solid fa-chevron-down",
      time: "fa-solid fa-clock",
      date: "fa-solid fa-calendar",
      today: "fa-solid fa-crosshairs",
      clear: "fa-solid fa-trash",
      close: "fa-solid fa-xmark"
    }
  });
  return $this.datetimepicker('show');
});

$(document).on('hidden.bs.modal', '#modal', function() {
  return $(this).empty();
});

}).call(window);
